import { getLocalStorage, LS_AUTH } from '../lib/storage';

export const AUTH = 'auth';
export const DASHBOARD = 'dashboard';
export const INTERVENTO = 'intervento';
export const INTERVENTO_CORRELATI = 'correlati';
export const INTERVENTO_DATI = 'dati';
export const USER = 'utente';
export const USERS = 'utenti';
export const CLIENTI = 'clienti';
export const CLIENTE = 'cliente';
export const APPARECCHIATURE = 'apparecchiature';
export const APPARECCHIATURA = 'apparecchiatura';
export const CERTIFICAZIONI = 'certificazioni';
export const CERTIFICAZIONE = 'certificazione';
export const RICHIEDENTI = 'richiedenti';
export const RICHIEDENTE = 'richiedente';
export const TIPILAVORI = 'tipilavori';
export const TIPILAVORO = 'tipilavoro';
export const MATERIALI = 'materiali';
export const MATERIALE = 'materiale';
export const MODELLI = 'modelli';
export const MODELLO = 'modello';
export const COSTRUTTORI = 'costruttori';
export const COSTRUTTORE = 'costruttore';
export const ATTIVITA = 'attivita';
export const PARTI = 'parti';
export const ATTIVITA_IT = 'attivitait';
export const PARTI_IT = 'partiit';
export const SEARCH = 'search';
export const LOG = 'log';
export const LASTLOG = 'lastLog';

export const getBaseApi = (type = 'auth') => {
  const map = {
    auth: `${AUTH}/`,
    dashboard: `${DASHBOARD}/data`,
    search: `${SEARCH}`,
    utente: `${USER}`,
    utenti: `${USERS}`,
    cliente: `${CLIENTE}`,
    clienti: `${CLIENTI}`,
    apparecchiatura: `${APPARECCHIATURA}`,
    apparecchiature: `${APPARECCHIATURE}`,
    certificazioni: `${CERTIFICAZIONI}`,
    certificazione: `${CERTIFICAZIONE}`,
    richiedenti: `${RICHIEDENTI}`,
    richiedente: `${RICHIEDENTE}`,
    tipilavori: `${TIPILAVORI}`,
    tipilavoro: `${TIPILAVORO}`,
    materiali: `${MATERIALI}`,
    materiale: `${MATERIALE}`,
    modelli: `${MODELLI}`,
    modello: `${MODELLO}`,
    costruttori: `${COSTRUTTORI}`,
    costruttore: `${COSTRUTTORE}`,
    attivita: `${ATTIVITA}`,
    parti: `${PARTI}`,
    intervento: `${INTERVENTO}`,
    correlati: `${INTERVENTO}/${INTERVENTO_CORRELATI}`,
    dati: `${INTERVENTO}/${INTERVENTO_DATI}`,
    attivitait: `${INTERVENTO}/${ATTIVITA}`,
    partiit: `${INTERVENTO}/${PARTI}`,
    lastLog: `${LOG}/data`,
  };

  return process.env.REACT_APP_PUBLIC_URL_API + (map[type] || 'auth');
};

const getBearer = () => `Bearer ${getLocalStorage(LS_AUTH)}`;

// Funzione interna per centralizzare le configurazioni di fetch
async function request(url, method, body = null, isFile = false) {
  const config = {
    method,
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      Authorization: getBearer(),
      'X-API-Generator': 'fefoweb/TechIntervention',
    },
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  };

  if (body) {
    if (isFile) {
      config.body = body;
      // Content-Type non va impostato per FormData, lo fa il browser con il boundary corretto
    } else {
      config.headers['Content-Type'] = 'application/json';
      config.body = JSON.stringify(body);
    }
  }

  const response = await fetch(url, config);

  // Gestione centralizzata errore 401 (Token scaduto)
  if (response.status === 401) {
    // Qui potresti aggiungere una logica di redirect o refresh
    console.warn('Sessione scaduta');
  }

  return response.json();
}

export async function postData(url = '', data = {}) {
  return request(url, 'POST', data);
}

export async function postDataFile(url = '', data = {}) {
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });
  formData.append('_method', 'PUT');
  return request(url, 'POST', formData, true);
}

export async function putData(url = '', data = {}) {
  return request(url, 'PUT', data);
}

export async function getData(url = '') {
  return request(url, 'GET');
}

export async function deleteData(url = '') {
  return request(url, 'DELETE');
}
